import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, ApiError, queryClient } from '../api';
import { ConsoleBrand } from '../auth';
import { Notice } from '../ui/kit';

export function Login() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [org, setOrg] = useState('');
  const [error, setError] = useState<string | null>(params.get('error') === 'not_authorized' ? 'Your Microsoft account is not an administrator of this organisation.' : params.get('error') ? 'Single sign-on failed. Try again.' : null);
  const [busy, setBusy] = useState(false);
  return (
    <div className="login">
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          try {
            await api('/auth/login', { method: 'POST', body: { email, password } });
            queryClient.clear();
            nav('/');
          } catch (err) {
            setError(err instanceof ApiError && err.status === 429 ? 'Too many attempts. Wait a minute and try again.' : err instanceof ApiError && err.status === 403 ? 'Password sign-in is disabled. Use Microsoft sign-in.' : 'Email or password is incorrect.');
          } finally {
            setBusy(false);
          }
        }}
      >
        <ConsoleBrand />
        <h1>Sign in</h1>
        {error && <Notice tone="block" role="alert">{error}</Notice>}
        <label className="field">Email<input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
        <label className="field">Password<input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
        <button className="btn primary" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        <div className="section-head mt-8"><span className="muted">Or with Microsoft Entra ID</span></div>
        <label className="field">Organisation ID<input value={org} onChange={(e) => setOrg(e.target.value.toLowerCase())} placeholder="e.g. acme" pattern="[a-z0-9\-]{2,40}" /></label>
        <a className="btn" href={org ? `/api/v1/auth/entra/start?org=${encodeURIComponent(org)}${email ? `&login_hint=${encodeURIComponent(email)}` : ''}` : undefined} aria-disabled={!org}>Sign in with Microsoft</a>
      </form>
    </div>
  );
}
